import { render, staticRenderFns } from "./BIconFile.vue?vue&type=template&id=f43eed4e&scoped=true&"
import script from "./BIconFile.vue?vue&type=script&lang=js&"
export * from "./BIconFile.vue?vue&type=script&lang=js&"
import style0 from "./BIconFile.vue?vue&type=style&index=0&id=f43eed4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43eed4e",
  null
  
)

export default component.exports